module.exports = __webpack_public_path__ + "img/icons_19.c4cfb6d3.svg";